import React, { useState, useEffect } from "react";

export default function RemovalModal({ show, seller, title, description, onConfirm, onCancel }) {
  const [reason, setReason] = useState("");

  useEffect(() => setReason(""), [show]); // reset on open/close

  if (!show || !seller) return null;

  const handleConfirm = () => {
    if (!reason.trim()) {
      alert("Please provide a reason before removing.");
      return;
    }
    onConfirm(reason);
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", zIndex: 1200 }}
      onClick={onCancel}
    >
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content p-4 rounded-3">
          <div className="d-flex justify-content-center mb-3">
            <img
              src="/images/remove.svg"
              alt={seller.name}
              className="rounded-circle"
              width={90}
              height={90}
            />
          </div>

          <h5 className="fw-bold mb-2 text-start" style={{ color: "#071437" }}>
            {title || "You’re about to reject a seller."}
          </h5>

          <p className="mb-3 text-start" style={{ color: "#80829A", fontSize: "14px" }}>
            {description ||
              `Are you sure you want to reject his interest for this RFQ? This action cannot be undone.`}
          </p>

          <label className="form-label text-start d-block" style={{ color: "#181D4C" }}>
            Please tell us more
          </label>
          <textarea
            className="form-control mb-4"
            rows="3"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Please tell us more"
          ></textarea>

          <div className="d-flex justify-content-evenly gap-2">
            <button className="btn w-100 btn-outline-dark px-3" onClick={onCancel}>
              Cancel Removal
            </button>
            <button
              className="btn w-100 px-3"
              style={{ backgroundColor: "#181D4C", color: "#fff" }}
              onClick={handleConfirm}
            >
              Remove Anyway
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
